import React, { Component } from "react";
import IconDot from "react-icons/lib/md/fiber-manual-record";
var dateFormat = require("dateformat");
class ReportTable extends Component {
  // constructor(props) {
  // super(props);
  // }
  render() {
    var cusorPointer = { cursor: "pointer" };
    console.log("this.props", this.props);
    return (
      <div>
        <table className="table">
          <thead>
            <tr>
              <th>Id</th>
              <th>Audit Date</th>
              <th>Score</th>
              <th>Status</th>
              <th>Audit by</th>
              {/* <th>State</th>
                     <th>Facility</th> */}
              {/* <th>Rectification by</th> */}
              <th>Rectification Date</th>
              <th>PDF Reports</th>
            </tr>
          </thead>
          <tbody>
            {this.props.reportFillData.map((item, i) => (
              <tr key={i}>
                <th scope="row">{i + 1}</th>
                <td>{dateFormat(item.audit_start_datetime, "mediumDate")}</td>
                <td>{item.audit_score}</td>
                <td>
                  <IconDot size="12" color={item.audit_status === 1 ? "#4CAF50" : "#F44336"} />
                  &nbsp;{item.audit_status === 1 ? "done" : "pending"}
                </td>

                <td>
                  {item.first_name === null ? (
                    "---"
                  ) : (
                    <span>
                      {item.first_name} {item.last_name}
                    </span>
                  )}
                  {/* {item.audit_by} */}
                </td>
                <td>{dateFormat(item.rectification_date, "mediumDate")}</td>
                <td>
                  {item.full_report_link ? (
                    <a className="btn btn-sm btn-primary" style={cusorPointer} onClick={() => this.props.preSignedUrl(item.full_report_link)}>
                      Full
                    </a>
                  ) : null}
                  {item.graph_report_link ? (
                    <a className="btn btn-sm btn-info" style={cusorPointer} onClick={() => this.props.preSignedUrl(item.graph_report_link)}>
                      Graph
                    </a>
                  ) : null}
                  {item.rectification_report_link ? (
                    <a className="btn btn-sm btn-warning" style={cusorPointer} onClick={() => this.props.preSignedUrl(item.rectification_report_link)}>
                      Rectification
                    </a>
                  ) : null}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    );
  }
}

ReportTable.defaultProps = {
  reportFillData: [],
  preSignedUrl: "",
};

export default ReportTable;



// WEBPACK FOOTER //
// ./src/views/reports/report_table.js